import { IPayloadAction } from "../../../../react-core/Flux/PayloadStore";

import { ActionType } from "../../../../react-core/Flux/ActionType";
import { SessionSettingConfiguration } from "../../../../Wrap/Models/Models/Session/SessionSettingConfiguration";
import { SessionSettingClient } from "../../../../Wrap/Api/Session/SessionSetting";
import { SessionSettingDispatcher } from "./Variables";

export type ISessionSettingActions = IPayloadAction<SessionSettingConfiguration>;

export class SessionSettingActions {
    public static get(callback?: (val: SessionSettingConfiguration) => void): void {
        const client = new SessionSettingClient();
        const promise = client.get();

        promise.onSuccess((response) => {
            if (callback) {
                callback(response);
            }
            SessionSettingDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: response,
            });
        });
    }
}
